import { EllipsisText, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { ExamCenterLocationUsageActionMenu } from '../../containers/exam-center-location-usage-action-menu';

import { type AdminExamCenterLocationUsageItem } from './types';

export const columns: GridColDef<AdminExamCenterLocationUsageItem>[] = [
  {
    field: 'examCenterCode',
    headerName: 'ศูนย์ทดสอบ',
    width: 160,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'requestedAt',
    headerName: 'วันที่ขอสิทธิ์ใช้งาน',
    sortable: false,
    width: 200,
    renderCell: (params) => <EllipsisText>{formatDateTime(params.row.requestedAt)}</EllipsisText>,
  },
  {
    field: 'approvedAt',
    headerName: 'วันที่อนุมัติสิทธิ์ใช้งาน',
    sortable: false,
    width: 200,
    renderCell: (params) => <EllipsisText>{formatDateTime(params.row.approvedAt)}</EllipsisText>,
  },
  {
    field: 'approvedBy',
    headerName: 'ผู้อนุมัติ',
    sortable: false,
    minWidth: 408,
    flex: 1,
    renderCell: (params) => <EllipsisText>{params.row.approvedBy.join(', ')}</EllipsisText>,
  },
  {
    field: 'actions',
    headerName: '',
    sortable: false,
    width: 48,
    renderCell: (params) => <ExamCenterLocationUsageActionMenu row={params.row} />,
  },
];
